<template>
  <div>
        <div>{{ addonCat.name }}?</div>
        <div class="relative" v-if="addonCat.multiple == 0">
            <select v-model="productAddon" :name="name" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <option v-for="addon in addonCat.addons" :key="addon.id" :value="addon">
                    {{addon.name}} <span v-if="addon.price">(+{{addon.price}})</span>
                </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
        </div>
        <div v-else v-for="addon in addonCat.addons" :key="addon.id">
            <input type="checkbox" :id="addon.id+'-'+product_id" v-model="productAddons" :value="addon" />
            {{ addon.name }}
            <span v-if="addon.price">€ {{ addon.price }}</span>
        </div>
  </div>
</template>

<script>
export default {
    name: 'ht-list-item-addon-category',
    props: ['addonCat', 'product_id', 'name'],
    mounted() {
        this.productAddon = this.addonCat.addons[0];
    },
    data() {
        return {
            productAddon: null,
            productAddons: [],
        }
    },
    watch: {
        productAddon: function() {
            this.getAddon();
        },
        productAddons: function(e) {
            this.getAddons(e[0]);
        }
    },
    methods: {
        getAddon: function() {
            this.addonChecked(this.productAddon)
        },
        getAddons: function(addon) {
            if(!_.isEmpty(this.productAddons)) {
                this.$events.fire('addAddonWithMultiple', addon);
            }
        },
        addonChecked: function(addon) {
            console.log(addon)
            for( let i in this.addonCat.addons) {
                if(this.addonCat.addons[i].name === addon.name) {
                    this.$events.fire('addAddon', addon);
                }
            }
        }
    },
}
</script>

<style>

</style>
